import * as React from 'react';
import { useComponentDefaultProps } from '../../../theming';
import { FixMeLater } from '../../../utils';
import { Styler, StylerBaseProps } from '../../Styler';
import { useStyles } from './ImageContent.styles';

export type ImageContentProps = StylerBaseProps;

const defaultProps: Partial<ImageContentProps> = {
    p: 4,
};

export const ImageContent: React.ForwardRefExoticComponent<ImageContentProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function ImageContent(
        props: ImageContentProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element {
        const { children, ...other } = useComponentDefaultProps('ImageContent', defaultProps, props);

        const { styles } = useStyles();

        return (
            <Styler ref={ref} baseStyles={styles.root} {...other}>
                {children}
            </Styler>
        );
    });
